import QuestionRenderer from "@components/assetrenderer/QuestionRender";
import SolutionRenderer from "@components/assetrenderer/SolutionRenderer";
import RubricComponent from "@components/rubriccomponent/RubricComponent";
import styles from "./QuestionRubricSolution.module.css";
import { ASSET_SOLUTION_INDEX } from "@constants/appConstants";

interface QuestionRubricSolutionProps {
  activeTab: "question" | "rubrics" | "solution";
  token: any;
  question: {
    question_id?: string | number;
    rubrics?: string;
  };
}

function QuestionRubricSolution({
  activeTab,
  token,
  question,
}: QuestionRubricSolutionProps) {
  if (!question?.question_id) return null;

  return (
    <div className={styles.container}>
      {/* -------- Question -------- */}
      {activeTab === "question" && (
        <QuestionRenderer
          key={`question-${question.question_id}`}
          questionId={question.question_id}
          fetchAssetFilter={{ with_solutions: true }}
          assetTypeProps={{
            isQuestionFinalized: true,
            showElements: {
              submitButton: false,
              solutions: false,
              hints: true,
              clearSelection: false,
            },
          }}
          title="Question"
          token={token}
        />
      )}

      {/* -------- Rubric -------- */}
      {activeTab === "rubrics" && (
        <RubricComponent
          title="Rubric"
          content={question.rubrics || ""}
        />
      )}

      {activeTab === "solution" && (
        <SolutionRenderer
          key={`solution-${question.question_id}`}
          questionId={question.question_id}
          fetchAssetFilter={{ with_solutions: true }}
          assetTypeProps={{
            isQuestionFinalized: true,
            solutionIndex: ASSET_SOLUTION_INDEX,
            showElements: {
              submitButton: false,
              solutions: true,
              hints: true,
              clearSelection: false,
            },
          }}
          title="Solution"
          token={token}
        />
      )}
    </div>
  );
}

export default QuestionRubricSolution;
